import { RootState } from "../store";

export const selectImageOptions = (state: RootState) => state.canvas.imageOptions;

export const selectTextOptions = (state: RootState) => state.canvas.textOptions;

export const selectBackgroundOptions = (state: RootState) => state.canvas.backgroundOptions;

export const selectIsSizeRatioLocked = (state: RootState) => state.canvas.isSizeRatioLocked;
